import { IButtonProperties } from '@vfde-brix/ws10/button';
import { getCMSConfig } from '../cms';
import { getUrl } from '../url';
import { QueryParam } from '../../enum';

/**
 * Get the properties for offer summary card button
 * @param {string} routerId - The selected router's id
 * @param {boolean} isLoggedIn - Whether the customer is logged in or not
 * @param {boolean} isContentEnabled - Whether any routers are available or not
 * @returns {Partial<IButtonProperties>} The properties to update on the button component
 */
export const getOfferSummaryCardButtonProps = (
    routerId: string,
    isLoggedIn: boolean,
    isContentEnabled: boolean,
): Partial<IButtonProperties> => {
    const { unlogged, logged, unavailable } = getCMSConfig().offerSummaryCard.button;

    let stdContent, linkHref, optDisabled = false;

    if (isLoggedIn) {
        stdContent = logged.text;
        linkHref = getUrl(logged.link, {
            [QueryParam.BASKET]: routerId,
        });
    } else {
        stdContent = unlogged.text;
        linkHref = getUrl(unlogged.link, {
            [QueryParam.TARGET_URL]: window.location.href,
        });
    }

    if (!isContentEnabled) {
        stdContent = unavailable.text;
        linkHref = unavailable.link;
    }

    return {
        stdContent,
        linkHref,
        optDisabled,
    };
};
